import React, { HTMLAttributes } from 'react';
import styled from 'styled-components';
import * as FormUI from '../../pages/pageForm/FormUI';
import { IconName, SvgIcon } from '../Icon';

interface IProps extends HTMLAttributes<HTMLDivElement> {
  placeholder: string;
  iconName: IconName;
  onClick: () => void;
  hidden: boolean;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 4px;
  width: 100%;
  &:hover {
    cursor: pointer;
  }
`;

const TableEditableCellPlaceholder = ({
  placeholder,
  iconName,
  hidden,
  ...props
}: IProps) => {
  return (
    <Container {...props} style={{ opacity: hidden ? 0 : 1 }}>
      <FormUI.OverflowingTextWrapper>
        {placeholder}
      </FormUI.OverflowingTextWrapper>
      <SvgIcon name={iconName} width={16} height={16} isHoverable />
    </Container>
  );
};

export default TableEditableCellPlaceholder;
